import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "ui/Scripts/source/framework/base";
import { SubPageHeader } from "../app/header";
import * as userFurtherEducationService from "../../models/services/userFurtherEducationService";
import { customHistory } from "../../framework/customHistory";
import { Session } from "../../models/session/session";
import { ActivePageType, NavigationBar } from "../app/navigation";
import { IUserState } from "../../models/store/storeTypes";
import { UserFurtherEducationListLine } from "./userFurtherEducationListLine";
import { IRecordListItemUserFurtherEducation, RecordListItemUserFurtherEducation } from "ui/Scripts/source/models/recordUserFurtherEducation/recordListItemUserFurtherEducation";
import { AppUtils } from "../../framework/appUtils";
import { ConfirmationDialogResult, UserFurtherEducationState } from "ui/Scripts/source/models/enums";
import { IRecordListItemUserQualification } from "ui/Scripts/source/models/recordUserQualification/recordListItemUserQualification";
import { UserQualificationListLine } from "./userQualificationListLine";
import { PanelTitle } from "../framework/panelTitle";
import { UserFurtherEducationListSearchDialog } from "./userFurtherEducationListSearch";

//UserFurtherEducationListMenu
export interface IUserFurtherEducationListMenuProp {
    item: IRecordListItemUserFurtherEducation;
    onEdit: () => void;
    onRemove: () => void;
    onCancel: () => void;
}

export class UserFurtherEducationListMenu extends React.Component<IUserFurtherEducationListMenuProp, {}> {
    handleEditClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onEdit();
    };

    handleRemoveClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onRemove();
    };

    handleCancelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onCancel();
    };
        
    render() {
        const item = this.props.item;
        if (!item) return null;
        return (
            <div className="listPopupMenu" onClick={this.handleCancelClick}>
                <div className="menu">
                    <div className="line" onClick={this.handleEditClick}>{Translations.Edit}</div>
                    <div className="line" onClick={this.handleRemoveClick}>{Translations.Remove}</div>
                    <div className="line" onClick={this.handleCancelClick}>{Translations.Cancel}</div>
                </div>
            </div>
        );
    }
}

//UserFurtherEducationList
export interface IUserFurtherEducationListOwnProps {
}

export interface IUserFurtherEducationListStateProps {
    user: IUserState;
    hasMore: boolean;
    isLoading: boolean;
    page: number;
    archived: boolean
    items: IRecordListItemUserFurtherEducation[];
    qualifications: IRecordListItemUserQualification[];
    sortColumn: string;
    lastOpenedUserFurtherEducationId: string;
}

export interface IUserFurtherEducationListDispatchProps {
    loadUserFurtherEducations: (page: number, archived: boolean) => void;
    removeUserFurtherEducation: (id: string) => void;
    resetUserFurtherEducations: () => void;
    refreshUserFurtherEducations: (page: number, archived: boolean) => void;
    setLastOpenedUserFurtherEducationId: (id: string) => void;
    setReturnUrl: (url: string) => void;
    onLogout: () => void;
}

type UserFurtherEducationListProp = IUserFurtherEducationListOwnProps & IUserFurtherEducationListStateProps & IUserFurtherEducationListDispatchProps;

interface IUserFurtherEducationListState {
    selectedId: string;
    showListMenu: boolean;
    showSearchDialog: boolean;
    listMenuItem: IRecordListItemUserFurtherEducation;
    companyName: string;
    validFurtherEducations: IRecordListItemUserFurtherEducation[];
    expiredFurtherEducations: IRecordListItemUserFurtherEducation[];
    archivedFurtherEducations: IRecordListItemUserFurtherEducation[];
}

export class UserFurtherEducationList extends React.Component<UserFurtherEducationListProp, IUserFurtherEducationListState> {
    private hasBeenInitialized: boolean;

    getValidFurtherEducations = (props: UserFurtherEducationListProp) => {
        return RecordListItemUserFurtherEducation.sortRecordListItemUserFurtherEducations(props.items ? props.items.filter(i => i.state === UserFurtherEducationState.Valid) : [], "validityDuration", false);
    };

    getExpiredFurtherEducations = (props: UserFurtherEducationListProp) => {
        return RecordListItemUserFurtherEducation.sortRecordListItemUserFurtherEducations(props.items ? props.items.filter(i => i.state === UserFurtherEducationState.Expired) : [], "validityEndDate", false);
    };

    getArchivedFurtherEducations = (props: UserFurtherEducationListProp) => {
        return RecordListItemUserFurtherEducation.sortRecordListItemUserFurtherEducations(props.items ? props.items.filter(i => i.state === UserFurtherEducationState.Archived) : [], "", true);
    };

    constructor(props: UserFurtherEducationListProp) {
        super(props);
        this.hasBeenInitialized = false;
        this.state = {
            selectedId: null,
            showListMenu: false,
            showSearchDialog: false,
            listMenuItem: null,
            companyName: "",
            validFurtherEducations: this.getValidFurtherEducations(props),
            expiredFurtherEducations: this.getExpiredFurtherEducations(props),
            archivedFurtherEducations: this.getArchivedFurtherEducations(props)
        };
    }

    //handleScrollSub = Base.debounce((obj: UserFurtherEducationList) => {
    //    if (obj.props.isLoading || !obj.props.hasMore) return;
    //    if (obj.listDiv.offsetHeight - (obj.containerDiv.clientHeight + obj.containerDiv.scrollTop) < 5) {
    //        obj.props.loadUserFurtherEducations(obj.props.page + 1);
    //    }
    //}, 100);

    //handleScroll = (message) => {
    //    this.handleScrollSub(this);
    //};

    handleLineLongPress = (id: string) => {
        const listMenuItem = this.props.items.find(i => i.id === id);
        if (Base.isNullOrUndefined(listMenuItem)) return;
        this.setState({
            selectedId: id,
            showListMenu: true,
            listMenuItem
        });
    };

    handleRefreshList = () => {
        const props = this.props;
        this.props.refreshUserFurtherEducations(props.page, props.archived);
    };

    componentDidMount(): void {
        const props = this.props;
        //this.containerDiv.addEventListener("scroll", this.handleScroll);
        if (props.page === 0) { //First load
            props.loadUserFurtherEducations(1, false);
        } else { //Edit back button
            props.refreshUserFurtherEducations(props.page, props.archived);
        }
        //Scroll last opened item to view
        //if (this.props.items.length > 0 && !Base.isNullOrEmpty(this.props.lastOpenedUserFurtherEducationId)) {
        //    if (this.containerDiv.scrollTo !== null && this.containerDiv.scrollTo !== undefined) {
        //        const index = this.props.items.findIndex(i => i.id === this.props.lastOpenedUserFurtherEducationId);
        //        if (index > -1) {
        //            const elements = this.containerDiv.getElementsByClassName("lom");
        //            if (elements.length > 0 && !Base.isNullOrUndefined(elements[0])) {
        //                const y = (elements[0] as HTMLDivElement).offsetTop;
        //                this.containerDiv.scrollTo({
        //                    top: y,
        //                    left: 0,
        //                    behavior: "auto"
        //                });
        //            }
        //        }
        //    }
        //    this.props.setLastOpenedUserFurtherEducationId("");
        //}
        //Set companyName
        Session.getCompanyName().then((companyName) => {
            this.setState({
                companyName
            });
        });
        this.hasBeenInitialized = true;
    }

    componentWillUnmount(): void {
        //this.containerDiv.addEventListener("scroll", this.handleScroll);
        this.props.resetUserFurtherEducations();
    }

    componentDidUpdate(prevProps: UserFurtherEducationListProp, prevState: IUserFurtherEducationListState): void {
        const props = this.props;
        const prevItemsHash = JSON.stringify(prevProps.items);
        const itemsHash = JSON.stringify(props.items);
        if (prevItemsHash === itemsHash) return;
        this.setState({
            validFurtherEducations: this.getValidFurtherEducations(props),
            expiredFurtherEducations: this.getExpiredFurtherEducations(props),
            archivedFurtherEducations: this.getArchivedFurtherEducations(props)
        });
    }

    removeUserFurtherEducation = async () => {
        const state = this.state;
        const props = this.props;
        if (!state.selectedId) return;
        const item = props.items.find(i => i.id === state.selectedId);
        if (!item) return;
        const result = await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToRemoveRecordFurtherEducationParameter, item.furtherEducationCode));
        if (result !== ConfirmationDialogResult.Yes) return;
        const success = await AppUtils.callService(() => userFurtherEducationService.removeUserFurtherEducation(item.id));
        if (!success) return null;
        props.removeUserFurtherEducation(item.id);
        props.refreshUserFurtherEducations(props.page, props.archived);
    };

    setReturnUrl = () => {
        this.props.setReturnUrl("/userfurthereducation");
    };

    handleLineClick = (id: string) => {
        this.props.setLastOpenedUserFurtherEducationId(id);
        this.setReturnUrl();
        customHistory.push("/userfurthereducation/" + id);
    };

    handleAddClick = () => {
        this.props.setLastOpenedUserFurtherEducationId("");
        this.setReturnUrl();
        customHistory.push("/userfurthereducation/" + Base.emptyGuid);
    };

    handleMenuEdit = () => {
        this.props.setLastOpenedUserFurtherEducationId(this.state.selectedId);
        this.setReturnUrl();
        customHistory.push("/userfurthereducation/" + this.state.selectedId);
        this.setState({
            showListMenu: false
        });
    };

    handleMenuRemove = () => {
        this.setState({
            showListMenu: false
        });
        this.removeUserFurtherEducation();
    };

    handleMenuCancel = () => {
        this.setState({
            showListMenu: false
        });
    };

    handleSearchFurtherEducations = () => {
        this.setState({
            showSearchDialog: true
        });
    };

    handleSearchDialogOk = (archived: boolean) => {
        this.setState({
            showSearchDialog: false
        });
        this.props.refreshUserFurtherEducations(1, archived);
    };

    handleSearchDialogCancel = () => {
        this.setState({
            showSearchDialog: false
        });
    };

    render() {
        const props = this.props;
        const state = this.state;
        const firstIndex = props.items.length > 0 ? 0 : -1;
        const nowDate = Date.now();
        const oneHourInMs = 60 * 60 * 1000;
        return (
            <div>
                <div className="pageContentContainer frontPage">
                    <div>
                        {props.qualifications.length > 0 &&
                            <div className="panelContainer">
                                <div className="panel userFurtherEducationPanel">
                                    <div className="commandRow">
                                        <PanelTitle
                                            classes="listTitle"
                                            title={Translations.Qualifications}
                                        />
                                    </div>
                                    <div className="panelContent listContainer userFurtherEducationListContainer">
                                        <div className="lineContainer mainLineContainer userFurtherEducationList">
                                            {props.qualifications.map((qualification) => (
                                                <UserQualificationListLine
                                                    key={qualification.id}
                                                    item={qualification}
                                                    selected={state.selectedId === qualification.furtherEducationId}
                                                    onClick={this.handleLineClick}
                                                    onLongPress={this.handleLineLongPress}
                                                    onRefreshList={this.handleRefreshList}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.hasBeenInitialized && !props.isLoading && props.items.length < 1 &&
                            <div className="infoContainer">
                                <div className="alert alert-info" role="alert" dangerouslySetInnerHTML={ { __html: Translations.NoFurtherEducationsToShow } } />
                            </div>
                        }
                        {state.validFurtherEducations.length > 0 &&
                            <div className="panelContainer">
                                <div className="panel userFurtherEducationPanel">
                                    <div className="commandRow">
                                        <PanelTitle
                                            classes="listTitle"
                                            title={Translations.ValidPlural}
                                        />
                                    </div>
                                    <div className="panelContent listContainer userFurtherEducationListContainer">
                                        <div className="lineContainer mainLineContainer userFurtherEducationList">
                                            {state.validFurtherEducations.map((item, index) => (
                                                <UserFurtherEducationListLine
                                                    key={item.id}
                                                    item={item}
                                                    selected={state.selectedId === item.id}
                                                    first={index === firstIndex}
                                                    recentlyUpdated={(nowDate - item.modifyDate) <= oneHourInMs}
                                                    isLastOpenedUserFurtherEducation={item.id === props.lastOpenedUserFurtherEducationId}
                                                    onClick={this.handleLineClick}
                                                    onLongPress={this.handleLineLongPress}
                                                    onRefreshList={this.handleRefreshList}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {state.expiredFurtherEducations.length > 0 &&
                            <div className="panelContainer">
                                <div className="panel userFurtherEducationPanel">
                                    <div className="commandRow">
                                        <PanelTitle
                                            classes="listTitle"
                                            title={Translations.ExpiredPlural}
                                        />
                                    </div>
                                    <div className="panelContent listContainer userFurtherEducationListContainer">
                                        <div className="lineContainer mainLineContainer userFurtherEducationList">
                                            {state.expiredFurtherEducations.map((item, index) => (
                                                <UserFurtherEducationListLine
                                                    key={item.id}
                                                    item={item}
                                                    selected={state.selectedId === item.id}
                                                    first={index === firstIndex}
                                                    recentlyUpdated={(nowDate - item.modifyDate) <= oneHourInMs}
                                                    isLastOpenedUserFurtherEducation={item.id === props.lastOpenedUserFurtherEducationId}
                                                    onClick={this.handleLineClick}
                                                    onLongPress={this.handleLineLongPress}
                                                    onRefreshList={this.handleRefreshList}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {state.archivedFurtherEducations.length > 0 &&
                            <div className="panelContainer">
                                <div className="panel userFurtherEducationPanel">
                                    <div className="commandRow">
                                        <PanelTitle
                                            classes="listTitle"
                                            title={Translations.Archived}
                                        />
                                    </div>
                                    <div className="panelContent listContainer userFurtherEducationListContainer">
                                        <div className="lineContainer mainLineContainer userFurtherEducationList">
                                            {state.archivedFurtherEducations.map((item, index) => (
                                                <UserFurtherEducationListLine
                                                    key={item.id}
                                                    item={item}
                                                    selected={state.selectedId === item.id}
                                                    first={index === firstIndex}
                                                    recentlyUpdated={(nowDate - item.modifyDate) <= oneHourInMs}
                                                    isLastOpenedUserFurtherEducation={item.id === props.lastOpenedUserFurtherEducationId}
                                                    onClick={this.handleLineClick}
                                                    onLongPress={this.handleLineLongPress}
                                                    onRefreshList={this.handleRefreshList}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    {/*<div className="userFurtherEducationListContainer mainListContainer" ref={(elem) => { this.containerDiv = elem; }}>*/}
                    {/*    <div className="lineContainer mainLineContainer userFurtherEducationList" ref={(elem) => { this.listDiv = elem; } }>*/}
                    {/*        {this.hasBeenInitialized && !props.isLoading && props.items.length < 1 &&*/}
                    {/*            <div className="infoContainer">*/}
                    {/*                <div className="alert alert-info" role="alert" dangerouslySetInnerHTML={ { __html: Translations.NoFurtherEducationsToShow } } />*/}
                    {/*            </div>*/}
                    {/*        }*/}
                    {/*        {props.qualifications.length > 0 &&*/}
                    {/*            <ListLine*/}
                    {/*                id={""}*/}
                    {/*                first={true}*/}
                    {/*                selected={false}*/}
                    {/*                classes="line dataTitle gray"*/}
                    {/*                onRefreshList={this.handleRefreshList}>*/}
                    {/*                <div className="row">*/}
                    {/*                    <div className="col col-12">{Translations.Qualifications}</div>*/}
                    {/*                </div>*/}
                    {/*            </ListLine>*/}
                    {/*        }*/}
                    {/*        {props.qualifications.map((qualification, index) => (*/}
                    {/*            <UserQualificationListLine*/}
                    {/*                key={qualification.id}*/}
                    {/*                item={qualification}*/}
                    {/*                selected={state.selectedId === qualification.furtherEducationId}*/}
                    {/*                onClick={this.handleLineClick}*/}
                    {/*                onLongPress={this.handleLineLongPress}*/}
                    {/*                onRefreshList={this.handleRefreshList}*/}
                    {/*            />*/}
                    {/*        ))}*/}
                    {/*        {props.items.map((item, index) => (*/}
                    {/*            <UserFurtherEducationListLine*/}
                    {/*                key={item.id}*/}
                    {/*                item={item}*/}
                    {/*                selected={state.selectedId === item.id}*/}
                    {/*                first={index === firstIndex}*/}
                    {/*                recentlyUpdated={(nowDate - item.modifyDate) <= oneHourInMs}*/}
                    {/*                isLastOpenedUserFurtherEducation={item.id === props.lastOpenedUserFurtherEducationId}*/}
                    {/*                onClick={this.handleLineClick}*/}
                    {/*                onLongPress={this.handleLineLongPress}*/}
                    {/*                onRefreshList={this.handleRefreshList}*/}
                    {/*            />*/}
                    {/*        ))}*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
                {state.showListMenu &&
                    <UserFurtherEducationListMenu
                        item={state.listMenuItem}
                        onEdit={this.handleMenuEdit}
                        onRemove={this.handleMenuRemove}
                        onCancel={this.handleMenuCancel}
                    />
                }
                {state.showSearchDialog &&
                    <UserFurtherEducationListSearchDialog
                        archived={props.archived}
                        onOk={this.handleSearchDialogOk}
                        onCancel={this.handleSearchDialogCancel}
                    />
                }
                <NavigationBar
                    activePage={ActivePageType.FurtherEducation}
                    user={props.user}
                />
                <SubPageHeader
                    user={props.user}
                    title={Translations.FurtherEducations}
                    searchIsSet={props.archived}
                    onSearch={this.handleSearchFurtherEducations}
                    onAdd={this.handleAddClick}
                />
            </div>
        );
    }
}